import { useState, useEffect, useRef } from "react";
import { Form, Button, Modal } from "react-bootstrap";
import stringUtilities from "../../../utilities/stringUtilities";
import useApi from '../../../utilities/useApi';
import ErrorModal from '../errorModal'
import OrganisationSelector from '../organisationSelector';
export const OrganisationAddEdit = ({isAdd, id, name, setName, parentId, setParentId, organisationalUnits, disabled, setDisabled, createShard, setCreateShard, isGlobalAdmin, headerImage, setHeaderImage, footerImage, setFooterImage, handleCancel, handleSubmit}) => {
    const [canSave, setCanSave] = useState(false);
    const [deleteImage, setDeleteImage] = useState(null)
    const [errorMessage, setErrorMessage] = useState(null)
    const headerImageInputRef = useRef();
    const footerImageInputRef = useRef();
    const headerImagePreviewRef = useRef();
    const footerImagePreviewRef = useRef();
    const { api } = useApi();

    useEffect(() => setCanSave(!stringUtilities.isNullOrEmpty(name) && (!isAdd || !stringUtilities.isNullOrEmpty(parentId))), [name, parentId])

    const handleChange = (inputRef, previewRef, imagePropertyName) => {
        if (inputRef.current && previewRef.current && inputRef.current.files[0]) {
            const inputFile = inputRef.current.files[0];
            if (inputFile) {
                api.updateOrganisationFile(id, inputFile, imagePropertyName,
                    data => {
                        if (data.isError) {
                            setErrorMessage(data.errorMessage)
                        } else {
                            if (imagePropertyName === "map-header") {
                                setHeaderImage({
                                    filename: !stringUtilities.isNullOrEmpty(data.mapHeader) ? data.mapHeader.split("/").pop() : null,
                                    fullPath: data.mapHeader,
                                })
                                previewRef.current.setAttribute('src', data.mapHeader)
                            } else if (imagePropertyName === "map-footer") {
                                setFooterImage({
                                    filename: !stringUtilities.isNullOrEmpty(data.mapFooter) ? data.mapFooter.split("/").pop() : null,
                                    fullPath: data.mapFooter,
                                })
                                previewRef.current.setAttribute('src', data.mapFooter)
                            }
                        }
                    },
                    error => {
                        setErrorMessage(error.message)
                    }
                )
            }
        }
    }

    const handleDelete = (deleteImageObject) => {
        if (deleteImageObject.previewRef.current) {
            api.deleteOrganisationProperty(id, deleteImageObject.imagePropertyName, 
                data => {
                    if (data.isError) {
                        setDeleteImage(null)
                        setErrorMessage(data.errorMessage)
                    } else {
                        deleteImageObject.setStateCallback(null)
                        deleteImageObject.previewRef.current.setAttribute('src', "")
                        setDeleteImage(null)
                    }
                },
                error => {
                    console.log(error)
                    setErrorMessage(error.Message)
                }
            )
        }
    }

    useEffect(() => {
        if (headerImagePreviewRef.current && footerImagePreviewRef.current) {
            headerImagePreviewRef.current.setAttribute('src', !stringUtilities.isNullOrEmpty(headerImage?.fullPath) ? headerImage?.fullPath : "");
            footerImagePreviewRef.current.setAttribute('src', !stringUtilities.isNullOrEmpty(footerImage?.fullPath) ? footerImage?.fullPath : "");
        }
    }, [])

    return (
        <>
            {!isAdd && <Form.Group className='mt-4 row justify-content-end'>
                <Form.Label className='form-label fs-sm col-form-label col-md-3'>
                    ID
                </Form.Label>
                <div className="col-md-9 d-flex align-items-center">
                    <Form.Control size='sm' value={id} type="text" plaintext readOnly />
                </div>
            </Form.Group>}
            {isAdd && <Form.Group className='mt-4 mb-3 row'>
                <Form.Label className='form-label fs-sm col-form-label col-md-3'>
                    Parent
                </Form.Label>
                <div className="col-md-9 d-flex align-items-center">
                    <OrganisationSelector wrapperClassAddon="w-100" hideIcon value={ parentId } organisations={ (organisationalUnits ?? []).filter(o => !o.deleted && !o.disabled) } onChange={ setParentId } />
                </div>
            </Form.Group>}
            <Form.Group className='mb-3 row'>
                <Form.Label className='form-label fs-sm col-form-label col-md-3'>
                    Name
                </Form.Label>
                <div className="col-md-9 d-flex align-items-center">
                    <Form.Control size='sm' value={ name } type="text" onChange={ (e) => setName(e.target.value) } />
                </div>
            </Form.Group>
            {isAdd && <Form.Group className='mb-3 row'>
                <Form.Label className='form-label fs-sm col-form-label col-md-3'>
                    Disabled
                </Form.Label>
                <div className="col-md-9 d-flex align-items-center">
                    <Form.Check type='switch' id="organisation-disabled" checked={ disabled } onChange={ (e) => setDisabled(e.target.checked) } />
                </div>
            </Form.Group>}
            {isAdd && isGlobalAdmin && <Form.Group className='mb-3 row'>
                <Form.Label className='form-label fs-sm col-form-label col-md-3'>
                    Create new shard database
                </Form.Label>
                <div className="col-md-9 d-flex align-items-center">
                    <Form.Check type='switch' id="organisation-create-shard" checked={ createShard } onChange={ (e) => setCreateShard(e.target.checked) } />
                </div>
            </Form.Group>}
            {isAdd && isGlobalAdmin && createShard && <Form.Group className='mb-3 row'>
                <Form.Label className='form-label fs-sm col-form-label col-md-3'>
                    Shard Name
                </Form.Label>
                <div className="col-md-9 d-flex align-items-center">
                    <Form.Control size='sm' value={ `shard-${ (name ?? "").trim().toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/[^a-z0-9\s_-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "") }` } type="text" plaintext readOnly />
                </div>
            </Form.Group>}
            {!isAdd && <>
            <Form.Group className='mb-3 row mt-4'>
                <Form.Label className='form-label fs-sm col-form-label col-md-3'>
                    Map Header Image
                </Form.Label>
                <div className="col-md-9 d-flex flex-column gap-2 file-input">
                    <input className="file-upload-button" ref={headerImageInputRef} onChange={() => handleChange(headerImageInputRef, headerImagePreviewRef, "map-header")} type="file" id="map-header-fileUpload" name="map-header-image" accept='image/*' />
                    <div className="d-flex align-items-center">
                        <label htmlFor="map-header-fileUpload"><i className='fi-cloud-upload me-2'></i>Upload File</label>
                        <p className="m-0">{stringUtilities.isNullOrEmpty(headerImage?.filename) 
                            ? <>No file chosen</> 
                            : <span>{headerImage?.filename} <i onClick={() => setDeleteImage({
                                imagePropertyName: "map-header",
                                previewRef: headerImagePreviewRef,
                                setStateCallback: setHeaderImage,
                            })} role="button" className="fi-x"></i></span> }
                        </p>
                    </div>
                    <img ref={headerImagePreviewRef} />
                </div>
            </Form.Group>
            <Form.Group className='mb-3 row mt-4'>
                <Form.Label className='form-label fs-sm col-form-label col-md-3'>
                    Map Footer Image
                </Form.Label>
                <div className="col-md-9 d-flex flex-column gap-2 file-input">
                    <input className="file-upload-button" ref={footerImageInputRef} onChange={() => handleChange(footerImageInputRef, footerImagePreviewRef, "map-footer")} type="file" id="map-footer-fileUpload" name="map-footer-image" accept='image/*' />
                    <div className="d-flex align-items-center">
                        <label htmlFor="map-footer-fileUpload"><i className='fi-cloud-upload me-2'></i>Upload File</label>
                        <p className="m-0">{stringUtilities.isNullOrEmpty(footerImage?.filename) 
                            ? <>No file chosen</> 
                            : <span>{footerImage?.filename} <i onClick={() => setDeleteImage({
                                imagePropertyName: "map-footer",
                                previewRef: footerImagePreviewRef,
                                setStateCallback: setFooterImage,
                            })} role="button" className="fi-x"></i></span> }
                        </p>
                    </div>
                    <img ref={footerImagePreviewRef} />
                </div>
            </Form.Group>
            </>}
            <Form.Group className='mt-4 row justify-content-end'>
                <div className="col-md-9">
                    <Button onClick={ handleCancel } variant='outline-primary' size="sm">
                        Cancel
                    </Button>
                    <Button disabled={ !canSave } onClick={ handleSubmit } size='sm' className='ms-2'>
                        Submit
                    </Button>
                </div>
            </Form.Group>

            {deleteImage && <Modal show onHide={ () => setDeleteImage(null) } centered>
                <Modal.Header>
                    <Modal.Title className="d-flex gap-2 align-items-center">Delete image</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                   <p className='m-0'>
                        { deleteImage.imagePropertyName === "map-header" && <>Are you sure you want to delete the organisation's map header?</> }
                        { deleteImage.imagePropertyName === "map-footer" && <>Are you sure you want to delete the organisation's map footer?</> }
                   </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button size="sm" variant='secondary' onClick={ () => setDeleteImage(null)}>Close</Button>
                    <Button size="sm" variant='danger' onClick={ () => handleDelete(deleteImage)}>Confirm</Button>
                </Modal.Footer>
            </Modal>}

            {!stringUtilities.isNullOrEmpty(errorMessage) && <ErrorModal error={{message: errorMessage}} onDismiss={() => setErrorMessage(null)} />}
        </>
    )
}